import React from 'react'
import { Text, TextProps } from '@chakra-ui/react'

function BodyTextXS({ fontSize, ...rest }: TextProps) {
  return <Text fontSize={fontSize ?? { base: 'xs', md: 'sm' }} {...rest} />
}

function BodyTextS({ fontSize, ...rest }: TextProps) {
  return <Text fontSize={fontSize ?? { base: 'sm', md: 'md' }} {...rest} />
}

function BodyText({ fontSize, ...rest }: TextProps) {
  return <Text fontSize={fontSize ?? { base: 'md', md: 'lg' }} {...rest} />
}

function BodyTextLG({ fontSize, ...rest }: TextProps) {
  return <Text fontSize={fontSize ?? { base: 'lg', md: '2xl' }} {...rest} />
}

export { BodyTextXS, BodyTextS, BodyText, BodyTextLG }
